module.exports = __webpack_public_path__ + "img/tips6_3.f1592012.png";